import React from 'react';
import QuadPess from './QuadPess';
import { PessoasDB } from '../PessoasDB';

function Names() {
  return (
    <section className="services">
            <div className="container">
            <h2>Pesquisadores</h2>
                <div className="row">
                    
                  {
                    PessoasDB.map((user, i) => {
                    return (
                        <QuadPess  
                            key={i} 
                            nome={PessoasDB[i].nome} 
                            text1={PessoasDB[i].text1} 
                            text2={PessoasDB[i].text2} 
                            img={PessoasDB[i].img}
                            link={PessoasDB[i].link} 
                            funcao={PessoasDB[i].funcao} 
                        />
                        );
                    })
                  }
                </div>
              </div>
    </section>

 

  );
}

export default Names;